// extracted by mini-css-extract-plugin
module.exports = {"separator":"EditReport_separator__2cbQn","propertiesCheckbox":"EditReport_propertiesCheckbox__3xCmM","inputSuffixAside":"EditReport_inputSuffixAside__3_TkJ"};